import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import {
    withStyles, Button, Dialog, DialogTitle, DialogContent,
    TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TablePagination, Grid, Collapse
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import t from "../../../../../languages/pl";
import { buttonStyle } from "../buttonGroupStyle";
import NoData from './../../../../Common/NoDataRow';
import guid from './../../../../../utils/guid';
import moment from 'moment-timezone';
import clsx from 'clsx';
import { displayDateTimeFormat } from './../../../../../utils/staticData';
import TimePeriodPicker from "../../../../Filters/TimePeriodPicker";
import PinDropIcon from '@material-ui/icons/PinDrop';
import SelectDataFilter from './SelectDataFilter';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import WarningIcon from '@material-ui/icons/Warning';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SpeedIcon from '@material-ui/icons/Speed';
import { TooltipTop } from "../../../../Common/CustomTooltips";
import FilterListIcon from '@material-ui/icons/FilterList';

const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        maxHeight: "62vh"
    },
    extendedContainer: {
        margin: theme.spacing(1),
        maxHeight: "72vh"
    },
    dateCell: {
        maxWidth: 200,
        width: "20%"
    },
    cell: {
        textAlign: "left",
    },
    filters: {
        display: 'flex',
        alignItems: "center",
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        justifyContent: "center"
    },
    buttonLabel: {
        color: "#FFF"
    },
    infoCell: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: 37
    },
    iconCell: {
      paddingBottom: theme.spacing(0),
    },
    icon: {
        height: 20,
    },
    thinRow: {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
    },
    closeButton:{
        ...buttonStyle(theme),
        float: "right",
    },
    dialogTitle: {
        paddingBottom: theme.spacing(0)
    }
});
const initialPeriod = {
    startTime: moment().unix(),
    endTime: moment().unix()
};

const Data = props => {
    const { classes, name, data: inputData, onDialogOpen, onDataUpdate } = props;
    const [open, setOpen] = useState(false);
    const [period, setPeriod] = useState(initialPeriod);
    const [filter, setFilter] = useState([]);
    const [filteredElements, setFilteredElements] = useState(inputData);
    const [count, setCount] = useState(inputData.length);
    const initialRowsPerPage = 20;
    const [quantity, setQuantity] = useState(initialRowsPerPage);
    const [page, setPage] = useState(0);
    const [showFilters, setShowFilters] = useState(true);

    useEffect(() => {
        setFilter([]);
    }, [inputData]);

    useEffect(() => {
        let filtered = inputData.slice(page * quantity, page * quantity + quantity);
        setFilteredElements(filtered);
        setCount(inputData.length);

        if (inputData[inputData.length - 1])
            setPeriod(period => ({ ...period, startTime: inputData[inputData.length - 1].data }));
        else
            setPeriod(period => ({ ...period, startTime: moment().subtract(2, "days").unix() }));
    }, [inputData, page, quantity]);

    useEffect(() => {
        setPage(0);
    }, [filter]);




    useEffect(() => {
        let sorted = [];
        if(filter.includes("")){
            sorted = inputData;
            setFilter([]);
        }
        if (filter.length > 0) {
            let selectedFilters = [...filter];
            if(selectedFilters.includes('Logowanie kierowców')){
                const index = selectedFilters.indexOf('Logowanie kierowców');
                selectedFilters[index] = 'logowanie';
            }

            inputData.map(data => {
                selectedFilters.filter(f => {
                    if (f.toLowerCase() === data.typ.toLowerCase()) {
                        sorted.push(data);
                    }
                }
                );
            });
        } else {
            sorted = inputData;
        }

        let filtered = sorted.slice(page * quantity, page * quantity + quantity);
        setFilteredElements(filtered);
        setCount(sorted.length);
    }, [filter, page, quantity]);

    const handleChangeRowPerPage = e => {
        setPage(Math.floor(page *(quantity / e.target.value)));
        setQuantity(e.target.value);
    };

    const handlePageChange = (obj, number) => {
        setPage(number);
    };

    const handleDialogOpen = () => {
        setOpen(true);
        onDialogOpen && onDialogOpen();
    };

    const handleRedirect = (location) => {
        props.history.push({
            pathname: "/map",
            search: `?id=${name}&lat=${location.lat}&lon=${location.lon}`
        });
    };

    const handleDisplayedRows = (from, to, count) => {
        return `${from}-${to} z ${count}`;
    };

    const selectIcon = (type) => {
        if (type === 'zdarzenia krytyczne')
            return <WarningIcon style={{ color: 'red'}} className={classes.icon} />;
        if (type === 'zdarzenia')
            return <WarningIcon className={classes.icon} />;
        if (type === 'punkty gps')
            return <GpsFixedIcon className={classes.icon} />;
        if (type === 'pomiary')
            return <AssessmentIcon className={classes.icon} />;
        if (type === 'przekroczenia')
            return <SpeedIcon className={classes.icon} />;
        if (type === 'logowanie')
            return <VpnKeyIcon className={classes.icon} />;
    };

    const selectTooltipDescription = (type) =>{
        if (type === 'zdarzenia krytyczne')
            return t.criticalIncident;
        if (type === 'zdarzenia')
            return t.incident;
        if (type === 'punkty gps')
            return t.gpsPoint;
        if (type === 'pomiary')
            return t.measurement;
        if (type === 'przekroczenia')
            return t.overLimit;
        if (type === 'logowanie')
            return t.driverLog;
    };

    const printTable = (data) => {
        if(!data || !Array.isArray(data) || data.length === 0)
            return <NoData colSpan={3} />;
        return data.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell
                        className={clsx(classes.cell, classes.dateCell)}
                        size="small"
                    >
                        {moment.unix(row.data).format(displayDateTimeFormat)}
                    </TableCell>
                    <TableCell className={classes.iconCell}
                        size="small"
                    >
                        <TooltipTop title={selectTooltipDescription(row.typ)}>
                            {selectIcon(row.typ)}
                        </TooltipTop>
                    </TableCell>
                    <TableCell
                        className={classes.infoCell}
                        size="small"
                    >
                        {row.zdarzenie}
                        &nbsp;
                        {
                            row.punkty_gps
                            &&
                            <PinDropIcon
                                style={{cursor: "pointer"}}
                                onClick={() => handleRedirect(row.punkty_gps)}
                            />
                        }
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.data}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="md"
                onClose={() => setOpen(false)}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Grid>
                        {t.dataTitle}&nbsp;{name}

                        <Button
                            className={classes.closeButton}
                            variant="contained"
                            color="secondary"
                            onClick={() => setOpen(false)}
                        >
                            {t.close}
                        </Button>
                        <Button
                            className={classes.closeButton}
                            variant="contained"
                            color="secondary"
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            <FilterListIcon />
                        </Button>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Collapse in={showFilters}>
                        <div className={classes.filters}>
                            <SelectDataFilter
                                value={filter}
                                onChange={(value) => setFilter(value)}
                            />
                            <TimePeriodPicker
                                startDate={period.startTime}
                                endDate={period.endTime}
                                onChange={(e) => setPeriod(period => ({ ...period, [e.target.name]: e.target.value }))}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                classes={{ label: classes.buttonLabel }}
                                onClick={() => {
                                    onDataUpdate && onDataUpdate(period);
                                }}
                            >
                                {t.updateData}
                            </Button>
                        </div>
                    </Collapse>
                    <TableContainer className={showFilters ? classes.container : classes.container2}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={clsx(classes.headerCell, classes.dateCell, classes.cell, classes.thinRow)}>
                                        {t.date}
                                    </TableCell>
                                    <TableCell className={clsx(classes.headerCell, classes.cell, classes.thinRow)}>
                                        {t.type}
                                    </TableCell>
                                    <TableCell className={clsx(classes.headerCell, classes.cell, classes.thinRow)}>
                                        {t.info}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {printTable(filteredElements)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                        component="div"
                        labelRowsPerPage={t.quantityOfDisplayingElements}
                        nextIconButtonText={t.nextPage}
                        backIconButtonText={t.previousPage}
                        count={count}
                        rowsPerPage={quantity}
                        page={page}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handleChangeRowPerPage}
                        labelDisplayedRows={({ from, to, count }) => handleDisplayedRows(from, to, count)}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

Data.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    data: PropTypes.array,
    onDialogOpen: PropTypes.func,
    onDataUpdate: PropTypes.func,
    //router
    history: PropTypes.object
};

Data.defaultProps = {
    data: []
};

export default compose(
    withStyles(useStyles),
    withRouter
    )(Data);